export default "__VITE_ASSET__DSQscXiI__"